export default "<a href=\"https://apps.yourdriverhk.com\" class=\"btn btn-danger btn-raised btn-lg\" >\n  <i class=\"fa fa-calendar\">馬上預約！</i>  \n</a>\n"